<template>
  <div>
    <button type="button" ref="sidebarToggle" v-b-toggle.member-sidebar hidden></button>
    <GroupSidebar ref="groupSideBar" @groupEmit="groupFilter"></GroupSidebar>
    <MemberSidebar :member="memberDetail" />
    <div class="panel">
      <div class="panel-hdr d-block pt-4 p-3">
        <div class="d-flex justify-content-between mb-3">
          <b-button variant="primary" v-b-toggle.grouping-sidebar>
            Grouping
          </b-button>
          <exportCSV
            class="link btn buttons-csv buttons-html5 btn-primary mr-2"
            :data="exportData"
            :fields="exportFields"
            :header="exportHeaders"
            type="csv"
            :escapeCsv="false"
            :name="exportFileName"
          >
            <span>CSV</span>
          </exportCSV>
          <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                    <span class="mr-3">PDF</span>
                    <i class="arrow-down fas fa-angle-down"></i> 
                </button> -->
        </div>
        <div class="row">
          <div class="col-sm-3 d-flex flex-column">
            <label class="h5">Search Member Name</label>
            <input
              type="search"
              class="form-control ml-0 shadow-inset-1"
              :placeholder="$t('label.search')"
              v-model="searchMember"
              @input="searchMemberList"
            />
          </div>

          <div class="col-sm-3 d-flex flex-column">
            <label class="h5">Birthday</label>
            <select name="" v-model="filter.birthday" @change="filterByBday()" class="form-control">
              <option value="all">All</option>
              <option value="1">This Month</option>
              <option value="2">Within 1 to 3 Months</option>
              <option value="3">Within 3 to 6 Months</option>
            </select>
          </div>
          <div class="col-sm-6 d-flex flex-column">
            <label class="h5">Last Visit</label>
            <b-button-group size="sm">
              <b-button
                variant="outline-primary"
                :class="filter.lastVIsit == 'all' ? 'active' : ''"
                @click="filter.lastVisit = 'all'"
                >All</b-button
              >
              <b-button
                variant="outline-primary"
                :class="filter.lastVIsit == '1' ? 'active' : ''"
                @click="filter.lastVisit = '1'"
                >This Month</b-button
              >
              <b-button
                variant="outline-primary"
                :class="filter.lastVIsit == '2' ? 'active' : ''"
                @click="filter.lastVisit = '2'"
                >Within 1 to 3 Months</b-button
              >
              <b-button
                variant="outline-primary"
                :class="filter.lastVIsit == '3' ? 'active' : ''"
                @click="filter.lastVisit = '3'"
                >Within 3 to 6 Months</b-button
              >
            </b-button-group>
          </div>
        </div>
        <a class="link text-primary" @click="clearFilter">{{
          $t("button_link.clear_filter")
        }}</a>
      </div>
      <div class="panel-container">
        <div class="panel-content">
          <ul class="nav nav-tabs">
            <li
              class="nav-item"
              v-for="membershipTab in $i18n.messages[$i18n.locale].tab
                .membershipTabs"
              :key="membershipTab.id"
            >
              <a
                :class="{ active: selectedMembershipTab == membershipTab.id }"
                class="nav-link"
                @click="vipTab(membershipTab.id)"
                >{{ membershipTab.text }}</a
              >
            </li>
          </ul>
          <div
            v-if="isSpinnerShow"
            class="d-flex justify-content-center mt-3 mb-3"
          >
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <div
            class="panel-tag mt-3"
            v-if="!isSpinnerShow && totalEntries == 0"
          >
            {{ $t("table.no_records") }}
          </div>
          <div
            class="dataTables_wrapper dt-bootstrap4"
            v-if="!isSpinnerShow && totalEntries != 0"
          >
            <div class="row justify-content-end mt-2">
              <div class="col-auto pt-2">
                <span>{{
                  $t("table.pagination", {
                    startPage: startPage,
                    endPage: endPage,
                    totalEntries: totalEntries,
                  })
                }}</span>
              </div>
              <div class="col-auto">
                <b-pagination
                  class="ml-3"
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="totalEntries"
                  @input="handlePagination"
                ></b-pagination>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 overflow-auto">
                <b-table
                  striped
                  hover
                  bordered
                  :fields="fields"
                  :items="memberList"
                  :per-page="perPage"
                  :current-page="currentPage"
                  responsive
                  @row-clicked="rowClicked"
                >
                  <template #cell(index)="data">
                    {{ data.index + startPage }}
                  </template>
                  <template #cell(img)="data">
                    <img
                      class="profile-image-md rounded-circle"
                      :src="
                        data.item.memberImage != ''
                          ? getMemberImage(data.item.memberImage)
                          : require('@/assets/image/icon/profile.png')
                      "
                    />
                  </template>
                  <template #cell(bday)="data">
                    {{ data.item.dob == "0000-00-00" ? "-" : data.item.dob }}
                  </template>
                  <template #cell(membership)="data">
                    <h6
                      v-if="
                        data.item.vip == '0' &&
                        data.item.vvip == '0' &&
                        data.item.vvvip == '0'
                      "
                    >
                      <span
                        class="
                          badge
                          border border-secondary
                          text-secondary
                          fw-400
                        "
                        >N/A</span
                      >
                    </h6>
                    <h6 class="d-inline-block mr-2" v-if="data.item.vip != '0'">
                      <span class="badge badge-primary">{{
                        membershipTabs[1].text
                      }}</span>
                    </h6>
                    <h6
                      class="d-inline-block mr-2"
                      v-if="data.item.vvip != '0'"
                    >
                      <span class="badge badge-danger">{{
                        membershipTabs[2].text
                      }}</span>
                    </h6>
                    <h6
                      class="d-inline-block mr-2"
                      v-if="data.item.vvvip != '0'"
                    >
                      <span class="badge badge-warning">{{
                        membershipTabs[3].text
                      }}</span>
                    </h6>
                  </template>
                  <template #cell(sales)="data">
                    {{ isEmpty(data.item.lastSale) ? "-" : "sales" }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import GroupSidebar from "./Grouping_SideBar";
import MemberSidebar from "./Member_Details";
import { openDB } from "idb";
import {
  handleSessionExpired,
  setReturnData,
  idbOpen
} from "./../../../../assets/js/dashboard/dashboard.js";
export default {
  name: "memberList",
  components: {
    GroupSidebar,
    MemberSidebar,
  },
  data() {
    return {
      memberList: [],
      memberData: [],
      delta: 0,
      offset: 0,
      limit: 10000,
      exportHeaders: [],
      exportData: [],
      exportFileName: "",
      memberExportData: [],
      searchMember: "",
      selectedTabView: "",
      selectedLastVisit: {},
      selectedMembershipTab: "",
      isSpinnerShow: false,
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 100,
      perPage: 100,
      currentPage: 1,
      membershipTabs: [],
      memberDetail: {},
      db: null,
      filter: {
        lastVisit: "all",
        birthday: "all",
      },
      group:{},
      dateRange: {},
    };
  },
  computed: {
        exportFields() {
      var ret = {};
      ret["#"] = "index";
      ret["NAME"] = "name";
      ret["BIRTHDAY"] = "dob";
      ret["MOBILE"] = "mobile";
      ret["CREDITS"] = "credits";
      ret["OUTSTANDINGS"] = "outstanding";
      ret["ETHNIC"] = "ethnic";
      ret["GENDER"] = "gender";

      return ret;
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "img",
          label: "",
          thClass: "thead-themed text-center",
          tdClass: "text-center",
        },
        {
          key: "name",
          label: this.$i18n.t("table.header.name"),
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "mobile",
          label: this.$i18n.t("table.header.contact"),
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "bday",
          label: this.$i18n.t("table.header.birthday"),
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "membership",
          label: this.$i18n.t("table.header.membership"),
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "sales",
          label: "Sales",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "credits",
          label: "Credits",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
      ];
    },
  },
  methods: {
    async groupFilter(filter){
      this.group = filter;
      let obj = {
        credit:[],
        gender: null,
        marital: null,
        outstanding: []
      };
      this.memberList = await this.memberData.filter((item)=>{
        if(filter.credit !== null){
          switch(filter.credit){
            case 0: obj.credit[0] = 500; obj.credit[1] = Infinity;break;
            case 1: obj.credit[0] = 50; obj.credit[1] = 500; break;
            case 2: obj.credit[0] = 0; obj.credit[1] = 50;
          }
        }
        else{
          obj.credit[0] = 0; obj.credit[1] = Infinity;
        }
        if(filter.gender !== null){
          switch(filter.gender){
            case 0: obj.gender = "0"; break;
            case 1: obj.gender = "1";
          }
        }
        else{
          obj.gender = "01";
        }
        if(filter.marital !== null){
          switch(filter.marital){
            case 0: obj.marital = "0"; break;
            case 1: obj.marital = "1";
          }
        }
        else{
          obj.marital = "01";
        }
        if(filter.outstanding !== null){
          switch(filter.outstanding){
            case 0: obj.outstanding[0] = 500; obj.outstanding[1] = Infinity;break;
            case 1: obj.outstanding[0] = 50; obj.outstanding[1] = 500; break;
            case 2: obj.outstanding[0] = 0; obj.outstanding[1] = 50;
          }
        }
        else{
          obj.outstanding[0] = 0; obj.outstanding[1] = Infinity;
        }
        if(obj.credit[0]<=item.credits && obj.credit[1]>item.credits &&
        obj.gender.toString().includes(item.gender) &&
        obj.marital.toString().includes(item.marital) &&
        obj.outstanding[0] <= item.outstandings && obj.outstanding[1]>item.outstandings
        ){
          return item;
        }
      });
      this.paginationCalc();
    },
    rowClicked(item,index,event){
      this.memberDetail = item;
      this.$refs.sidebarToggle.click();
    },
    filterMemberByView(tab) {
      this.memberList = this.memberData.filter((item) => {
        switch (tab) {
          case "active":
            return item;
          case "hidden":
            if (item.hideDate != 0) return item;
            break;
          case "delete":
            if (item.deleteDate != 0) {return item;}
            break;
        }
      });
      this.totalEntries = this.memberList.length;
    },
    vipTab(tab) {
      this.selectedMembershipTab = tab;
      this.memberList = this.memberData.filter((item) => {
        switch (tab) {
          case "all":
            return item;
          case "memberVip":
            if (item.vip != 0) return item;
            break;
          case "memberVvip":
            if (item.vvip != 0) return item;
            break;
          case "memberVvvip":
            if (item.vvvip != 0) return item;
            break;
        }
      });
      this.paginationCalc();
    },
    paginationCalc(){
            this.totalEntries = this.memberList.length;
      if(this.memberList.length < this.endPage){
        this.endPage = this.memberList.length;
      }
      else{
        this.endPage = 100;
      }
    },
    async addData(data) {
      const tx = this.db.transaction("member_list", "readwrite");
      const store = tx.objectStore("member_list");
      store.put(data, "key");
      const date = new Date();
      const unixTimestamp = Math.floor(date.getTime() / 1000);
      store.put(unixTimestamp, "timestamp");
      await tx.done;
    },
    async getData() {
      const tx = this.db.transaction("member_list", "readwrite");
      const store = tx.objectStore("member_list");
      const res = await store.get("key");
      return res;
    },
    async setMemberList() {
      const tx = this.db.transaction("member_list", "readwrite");
      const store = tx.objectStore("member_list");
      this.delta = await store.get("timestamp");
      this.delta = this.delta == undefined ? 0 : this.delta;
      const newData = await this.getMemberList();
      this.memberList = await this.getData();
      console.log(this.memberList);
      //this.setExportData();
      if (newData.length != 0 || newData !== undefined || newData !== null) {
        this.memberList = this.memberList === undefined ? []:this.memberList;
        this.memberList = this.memberList.concat(newData);
        this.addData(this.memberList);
      }
      
      this.memberData = this.memberList;
      this.totalEntries = this.memberList.length;
    },
    async getMemberList() {
      let url =
        this.$api.MEMBER2 +
        "?delta=" +
        this.delta +
        "&offset=" +
        this.offset +
        "&limit=" +
        this.limit;
      var result = [];
      await this.$axios({
        method: "get",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.members.map((m) => ({
            ...m,
            ...response.data.ethnics.find((e) => e.ethnicID === m.ethnicID),
          }));
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
    searchMemberList() {
      this.memberList = this.memberData.filter((item) => {
        if (
          item.name.includes(this.searchMember) ||
          item.mobile.includes(this.searchMember)
        ) {
          return item;
        }
      });
      this.totalEntries = this.memberList.length;
    },
    clearFilter() {
      this.searchMember = "";
      this.filter = {
        lastVisit: "all",
        birthday: "all",
      };
      this.$refs.groupSideBar.resetGrouping();
    },
    handlePagination(pg) {
      if (pg != null) {
         this.page = pg;
        this.startPage =((pg-1)*100)+1;
        this.endPage = pg * 100;
        if(this.endPage>this.totalEntries){
          this.endPage = this.totalEntries;
        }
      }
    },
    getMemberImage(id) {},
    filterByBday() {
      this.memberList = this.memberData.filter(item=>{
        let dob = new Date(item.dob)
        switch(this.filter.birthday){
          case 'all': return item;
          case '1': if(new Date().getMonth()==dob.getMonth()) return item;
                    break;
          case '2': if(moment().add(1,'month').toDate().getMonth() >= dob.getMonth() && moment().add(3,'month').toDate().getMonth() <= dob.getMonth()) return item;
                    break;
          case '3': if(moment().add(4,'month').toDate().getMonth() >= dob.getMonth() && moment().add(6,'month').toDate().getMonth() <= dob.getMonth()) return item;
                    break;
        }
      })
      this.totalEntries = this.memberList.length;
    },
    async getMembershipTags() {
      let $vm = this;

      var init = ["memberVip", "memberVvip", "memberVvvip"];
      $vm.membershipTabs.push({ id: "all", text: "All" });
      await $vm
        .$axios({
          method: "get",
          url: this.$api.MEMBER_CONFIGURE,
          baseURL: this.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          var results = response.data.vip;

          for (var i = 0; i < results.length; i++) {
            $vm.membershipTabs.push({ id: init[i], text: results[i] });
            $vm.selectedMembershipTab = $vm.membershipTabs[0].id;
          }
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    setExportData() {
      this.exportData = [];
      let header =
        this.$msg.REPORT.HEADER + this.$i18n.t("subMenu.my_salon_member");
      this.exportHeaders = [
        header,
        this.$i18n.t("table.report_generate") +
          moment().format(this.$msg.CST.DATE_TIME_24),
        " ",
      ];

      this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV;
      const data = this.memberList;
      for (var i = 0; i < data.length; i++) {
        this.exportData.push({
          index: i + 1,
          birthday:data[i].dob,
          name: data[i].name,
          mobile: data[i].mobile,
          credits:data[i].credits,
          outstanding:data[i].outstandings,
          gender:data[i].gender,
          ethnic:data[i].ethnic
        });
      }
    },
  },
  async mounted() {
    let $vm = this;
    this.getMembershipTags();
    let dbName = $vm.$store.state.userName+"_memberList";
    this.db = await idbOpen(dbName,"member_list");
    this.setMemberList();
  },
};
</script>
